// @ts-nocheck
import { createContext, useContext } from "react";

type productListProductEvent = (isOpeningNewPage: boolean) => void;

export interface ProductListProductContextType {
    onImageClick?: productListProductEvent;
    onTitleClick?: productListProductEvent;
    onAddToCartClick?: productListProductEvent;
}

export const defaultContext: ProductListProductContextType = {};

export const ProductListProductContext = createContext<ProductListProductContextType>(defaultContext);

export const useProductListProductContext = () => {
    return useContext(ProductListProductContext);
};
